/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Nomatch2Inputs */

const zh_admincredit_nomatch2 = /** @type {(inputs: Admincredit_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到匹配的用户`)
};

const en_admincredit_nomatch2 = /** @type {(inputs: Admincredit_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching users found`)
};

const es_admincredit_nomatch2 = /** @type {(inputs: Admincredit_Nomatch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron usuarios coincidentes`)
};

/**
* | output |
* | --- |
* | "No matching users found" |
*
* @param {Admincredit_Nomatch2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_nomatch2 = /** @type {((inputs?: Admincredit_Nomatch2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Nomatch2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_nomatch2(inputs)
	if (locale === "en") return en_admincredit_nomatch2(inputs)
	return es_admincredit_nomatch2(inputs)
});
export { admincredit_nomatch2 as "adminCredit_noMatch" }